// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__26MKf","addWidgetButton":"Header_addWidgetButton__1Two-","dashboardTabs":"Header_dashboardTabs__3KIfK","active":"Header_active__3ffUB"};